'use client';

import { FusebaseLogo, Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

export function MobileBlocked() {
  const sliders = [
    {
      title: 'Streamline workflows',
      image: '/assets/img/mobile-demo-space.webp',
    },
    {
      title: 'Get more features first',
      image: '/assets/img/mobile-demo-portal.webp',
    },
    {
      title: 'Customize with ease',
      image: '/assets/img/mobile-demo-visual-editor.webp',
    },
  ];

  return (
    <div className="flex flex-col items-center bg-white">
      <div className="w-auto h-4 mt-10">
        <FusebaseLogo />
      </div>
      <div className="mt-16 text-center mb-8 px-4 text-[#002730]">
        <h1 className="text-3xl font-semibold mb-4 text-neutral-800">Thanks for signing up!</h1>
        <div className="mb-2 text-base">
          To experience <span className="font-bold">Fusebase</span> to its fullest, access the web version from your
          <div className="flex justify-center items-center">
            <Icon icon={IconsMap.COMPUTER} className="h-4 w-4 mr-1" /> desktop.
          </div>
        </div>
      </div>
      <div className="w-full bg-[#002730] pt-8 flex flex-col items-center">
        <div className="text-neutral-200 h-8 w-40 text-xs border border-neutral-200 flex justify-center items-center rounded-full">
          Why we recommend it
        </div>
        <div className="my-8 w-full">
          {sliders.map((slider, key) => {
            return (
              <div key={key} className="px-4 mb-6">
                <div className="bg-white/10 rounded-lg border border-white/20 pt-6 pl-6">
                  <div className="text-2xl text-white font-medium mb-4">{slider.title}</div>
                  <div className="rounded-tl-md rounded-br-md overflow-hidden">
                    <img src={slider.image} className="w-full h-full" alt="" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
